import React, { useEffect } from 'react'
import { Switch, Route } from 'react-router'
import { useHistory } from 'react-router-dom'
import { RouterState } from 'connected-react-router'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { toast } from '@services'

import {
  RootState,
  Dispatcher,
  AppState
} from 'AppTypes'

import { isJwtTokenExpired } from '@utils/jwt-token'

import { initMainLayout } from '@app/state_management/actions'

import Dashboard from '@features/dashboard/Dashboard'
import StoreManagement from '@features/store_management/StoreManagement'
import Video from '@features/videos/Video'
import LiveStream from '@features/live_stream/LiveStream'
import MenuManagement from '@features/menu_management/MenuManagement'
import Analytics from '@features/analytics/Analytics'

import { LoadingSpinner } from '@share/components'

import PageNotFoundLayout from './404'

import { MainToolbar, LeftSidebar, RightSidebar, Overlay } from './partials'

import './Main.css'

type Props = {
  appState: AppState
  routerState: RouterState
  dispatch: Dispatcher
}

/* eslint no-console: "off" */
/* eslint no-debugger: "off" */
const Main: React.FC<Props> = ({
  appState: {
    isMainLayoutInitialed
  },
  routerState: {
    location: {
      pathname: locationPathname
    }
  },
  dispatch
}) => {
  const history = useHistory()
  const { t } = useTranslation()

  if (locationPathname === '/') {
    history.replace('/dashboard')
  }

  useEffect(() => {
    const jwtToken = localStorage.getItem('jwtToken')
    const refreshToken = localStorage.getItem('refreshToken')
    const storeUserId = localStorage.getItem('storeUserId')

    if (!jwtToken || !storeUserId || (isJwtTokenExpired(jwtToken) && !refreshToken)) {
      window.location.replace(`/login?redirectTo=${encodeURIComponent(locationPathname)}`)
    }

    if (locationPathname === '/') {
      history.replace('/dashboard')
    }

    dispatch(initMainLayout()).then(
      () => {},
      reason => {
        console.log('Main layout initialed failed', reason)
        toast.error(t('messages.generalErrorMsg'))
      }
    )
  }, [dispatch])

  if (!isMainLayoutInitialed) {
    return (
      <div className="wrapper">
        <LoadingSpinner isShowing />
      </div>
    )
  }

  return (
    <>
      <div className="wrapper">
        <LeftSidebar />
        <div className="content-wrapper">
          <MainToolbar />
          <div className="content">
            <Switch>
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/store" component={StoreManagement} />
              <Route path="/video" component={Video} />
              <Route path="/live" component={LiveStream} />
              <Route path="/menu" component={MenuManagement} />
              <Route path="/analytics" component={Analytics} />
              <Route component={PageNotFoundLayout} />
            </Switch>
            <RightSidebar />
          </div>
        </div>
      </div>
      <Overlay />
    </>
  )
}

export default connect((state: RootState) => ({
  appState: state.app,
  routerState: state.router
}))(Main)
